import React from "react"
import Grid from "@mui/material/Grid";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {CmCollectionType, CmTeasableType} from "../../types";
import C010FactsCard from "./C010FactsCard";
import getSetting, {
    SETTING_FACTS_HEADLINE_MAX_LENGTH,
    SETTING_FACTS_TEASER_TITLE_MAX_LENGTH
} from "../../../pages/config/settings";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";


import type { CAEGlobalSettings } from "../../../types/CAEGlobalSettings";

export interface Props {
    cmCollection: CmCollectionType
    CAEGlobalSettings: CAEGlobalSettings
}

function C010Facts(props: Props) {
    const maxNumberOfItems = 3;
    const defaultHeadlineMaxLength = 60;
    const defaultTeaserTitleLength = 40;

    return (
        <CCOComponentWrapper background={"grey"}>
            <CCOHeadline id={props.cmCollection.id}
                         metadataId={props.cmCollection.id}
                         propertyName='properties.teaserTitle'
                         subtextPropertyName='properties.teaserText'
                         margin={{t: 12}}
                         type={"componenthead"}
                         headline={props.cmCollection.teaserTitle}
                         headlineCharLimit={getSetting(props.CAEGlobalSettings,
                                                       SETTING_FACTS_TEASER_TITLE_MAX_LENGTH,
                                                       defaultTeaserTitleLength)}
                         subtext={props.cmCollection.teaserText?.textAsTree}
                         subtextCharLimit={getSetting(props.CAEGlobalSettings,
                                                      SETTING_FACTS_HEADLINE_MAX_LENGTH,
                                                      defaultHeadlineMaxLength)}
                         background={"grey"}
            />
            <CCOContainer background={"grey"} width={"large"}>
                <Grid
                    container
                    sx={{
                        justifyContent: "center",
                        marginBottom: 10
                    }}>
                    {props.cmCollection.items ?
                        props.cmCollection.items?.slice(0, maxNumberOfItems).map(
                            i => i as CmTeasableType).map((i: any, index: number) => {
                                                          return (
                                                              <Grid
                                                                  key={index}
                                                                  size={{sm: 12, md: 4}}
                                                                  sx={{
                                                                      display: 'flex',
                                                                      alignItems: 'stretch',
                                                                      padding: 3,
                                                                      width: '100%'
                                                                  }}>
                                                                  <C010FactsCard item={i} CAEGlobalSettings={props.CAEGlobalSettings}/>
                                                              </Grid>
                                                          );
                                                      }
                        ) : null
                    }
                </Grid>
            </CCOContainer></CCOComponentWrapper>
    );
}

export default C010Facts